import { IBasicCourse } from '@sdk/contracts';
import { Flex } from 'antd';
import { useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { BoldText, ScrollableList, SeeMoreButton } from './ConfirmationContent.styles';

const INITIAL_VISIBLE_COURSES = 15;

type ConfirmationContentProps = {
  syncedCourses: IBasicCourse[];
};

export const ConfirmationContent: React.FC<ConfirmationContentProps> = ({ syncedCourses }) => {
  const { t } = useTranslation('ManagerBaseContentDetailTranslations');
  const [showAll, setShowAll] = useState(false);
  const isSingleSyncedCourse = syncedCourses.length === 1;
  const hasMoreCourses = syncedCourses.length > INITIAL_VISIBLE_COURSES;
  const remainingCourses = syncedCourses.length - INITIAL_VISIBLE_COURSES;
  const visibleCourses = showAll ? syncedCourses : syncedCourses.slice(0, INITIAL_VISIBLE_COURSES);

  return (
    <Flex vertical style={{ paddingBottom: 48 }}>
      <BoldText>{t('CONFIRM_SAVE_DESCRIPTION')}</BoldText>
      {isSingleSyncedCourse ? (
        <div>
          <Trans
            i18nKey="ManagerBaseContentDetailTranslations:SINGLE_SYNCED_COURSE"
            values={{ courseName: syncedCourses[0].name }}
            components={{ bold: <BoldText /> }}
          />
        </div>
      ) : (
        <>
          <div>
            <Trans
              i18nKey="ManagerBaseContentDetailTranslations:MULTIPLE_SYNCED_COURSES"
              components={{ bold: <BoldText /> }}
            />
          </div>
          <ScrollableList>
            {visibleCourses.map(course => (
              <li key={course._id}>{course.name}</li>
            ))}
          </ScrollableList>
          {hasMoreCourses && !showAll && (
            <SeeMoreButton type="link" onClick={() => setShowAll(true)} style={{ padding: 0 }}>
              {t('SEE_MORE_COURSES', { remainingCourses })}
            </SeeMoreButton>
          )}
        </>
      )}
    </Flex>
  );
};
